import {AbilityBuilder, AnyMongoAbility} from '@casl/ability';
import {PolicyIdentity} from './policy-account';
import {hasRole} from './policy-helpers';
import {SystemRoles} from './role.policies';

/**
 * Define global policies that apply across all domains
 *
 * CRITICAL: These are SAFETY NET rules for tenant isolation.
 * 'manage' = all actions, 'all' = all subjects
 */
export function defineGlobalPolicies(identity: PolicyIdentity, builder: AbilityBuilder<AnyMongoAbility>): void {
  // We use a relaxed builder with AnyMongoAbility because 'all' subject doesn't have typed properties,
  // but CASL supports conditions on 'all' at runtime
  const {can, cannot} = builder;

  // For each tenant membership, allow tenant admins to manage everything within their tenant.
  for (const account of identity.accounts) {
    if (hasRole(account, SystemRoles.TenantAdmin)) {
      can('manage', 'all', {tenantId: account.tenantId});
    }
  }

  // System admins bypass tenant isolation entirely.
  if (hasRole(identity, SystemRoles.SystemAdmin)) {
    can('manage', 'all');
  } else {
    // Prevent managing resources outside of the identity's tenants.
    const tenantIds = identity.accounts.map(acc => acc.tenantId);
    cannot('manage', 'all', {tenantId: {$nin: tenantIds}}).because('Cannot manage resources outside of your tenants');
  }
}
